import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListIdematsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'IdematComparisonModal',
  emits: ['closeModal', 'selectItem'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var tableHeaders = [{
      text: $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.emissionSources.idematComparisonModal.tableHeaders.name'),
      value: 'name',
      sortable: true
    }, {
      text: $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.emissionSources.idematComparisonModal.tableHeaders.category'),
      value: 'categoryFull',
      sortable: false
    }, {
      text: $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.emissionSources.idematComparisonModal.tableHeaders.ghgFactor'),
      value: 'ghgFactor',
      sortable: true
    }, {
      text: $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.emissionSources.idematComparisonModal.tableHeaders.unit'),
      value: 'unit',
      sortable: false
    }, {
      text: $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.emissionSources.idematComparisonModal.tableHeaders.notes'),
      value: 'notes',
      sortable: false
    }, {
      text: $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.emissionSources.idematComparisonModal.tableHeaders.source'),
      value: 'source',
      sortable: false
    }];
    var selected = ref([{}]);
    var input = ref({
      keyword: '',
      categories: [],
      units: []
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortBy: ['name'],
      sortDesc: [false]
    });
    var variables = computed(function () {
      return {
        input: {
          keyword: input.value.keyword || '',
          categories: input.value.categories || [],
          units: input.value.units || []
        },
        filters: {
          keyword: input.value.keyword || '',
          categories: input.value.categories || [],
          units: input.value.units || []
        },
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage,
        sort: options.value.sortBy.map(function (item, index) {
          return {
            field: String(item),
            sortDesc: options.value.sortDesc[index]
          };
        })
      };
    });
    var _useListIdematsQuery = useListIdematsQuery(variables),
      idematSearchResult = _useListIdematsQuery.result,
      loading = _useListIdematsQuery.loading;
    var itemCount = computed(function () {
      var _idematSearchResult$v, _idematSearchResult$v2;
      return (_idematSearchResult$v = (_idematSearchResult$v2 = idematSearchResult.value) === null || _idematSearchResult$v2 === void 0 ? void 0 : _idematSearchResult$v2.countIdemats) !== null && _idematSearchResult$v !== void 0 ? _idematSearchResult$v : 0;
    });
    var tableData = computed(function () {
      var _idematSearchResult$v3;
      return ((_idematSearchResult$v3 = idematSearchResult.value) === null || _idematSearchResult$v3 === void 0 ? void 0 : _idematSearchResult$v3.listIdemats) || [];
    });
    function fetchData(val) {
      if (val.keyword === null) {
        val.keyword = '';
      }
      input.value = val;
      options.value.page = 1;
    }
    var dialog = ref(false);
    function openDialog() {
      dialog.value = true;
    }
    function closeModal() {
      dialog.value = false;
      emit('closeModal');
    }
    function addIdematGHG() {
      if (selected.value.length > 0 && selected.value[0].id) {
        emit('selectItem', {
          name: selected.value[0].name,
          factor: selected.value[0].ghgFactor,
          unit: selected.value[0].unit,
          evidence: selected.value[0].source + ' (' + selected.value[0].idematId + ')',
          customBaselineConcept: false
        });
        closeModal();
      } else {
        // Nothing selected, do nothing
      }
    }
    return {
      __sfc: true,
      emit: emit,
      $i18n: $i18n,
      tableHeaders: tableHeaders,
      selected: selected,
      input: input,
      options: options,
      variables: variables,
      idematSearchResult: idematSearchResult,
      loading: loading,
      itemCount: itemCount,
      tableData: tableData,
      fetchData: fetchData,
      dialog: dialog,
      openDialog: openDialog,
      closeModal: closeModal,
      addIdematGHG: addIdematGHG
    };
  }
});